var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"upload-btn"},[_c('label',{attrs:{"for":"upload-file"}},[_c('i',{staticClass:"fas fa-file-alt"}),_vm._v(" Chọn file\n      "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"upload-file"},on:{"change":_vm.loadTextFromFile}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }